import React from 'react';
import PropTypes from 'prop-types';

const Button = (props) => (
    <span
        className={`${props.className} ${props.disabled ? 'disabled' : ''}`}
        onClick={props.onClick}
    >
        {props.children}
    </span>
);

Button.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool
};

export default Button;



// WEBPACK FOOTER //
// ./src/client/components/Button.js